const defaultRate = {
  baseRate: '0',
  timeAndAHalfRate: '0',
  doubleRate: '0',
  otherRate: '0',
};

const PURPLE = '#cc99ff';
const PINK = '#f298cc';
const GREEN = '#cbfecb';

const COMMON_RATES = [
  {
    id: 'FICA_SS_TAX',
    description: 'FICA S.S. TAX',
    color: PINK,
    ...defaultRate,
  },
  {
    id: 'FEDERAL_UNEMPLOYED_TAX',
    description: 'FEDERAL UNEMPLOYED TAX',
    color: PINK,
    ...defaultRate,
  },
  {
    id: 'STATE_UNEMPLOYED_TAX',
    description: 'STATE UNEMPLOYED TAX',
    color: PINK,
    ...defaultRate,
  },
  {
    id: 'Workers_Compensation_Ins',
    description: 'Workers Compensation Ins.',
    color: GREEN,
    ...defaultRate,
  },
  {
    id: 'General_Liability_Insurance',
    description: 'General Liability Insurance',
    color: GREEN,
    ...defaultRate,
  },
  {
    id: 'Unbrella_Insurance',
    description: 'Unbrella Insurance',
    color: GREEN,
    ...defaultRate,
  },
  {
    id: 'Automobile_Crime_Property',
    description: 'Automobile / Crime / Property',
    color: GREEN,
    ...defaultRate,
  },
];
export const DEFAULT_LABOR_RATE_LIST = [
  {
    id: 'BASE_RATE',
    description: 'BASE RATE',
    color: '#ccfeff',
    ...defaultRate,
  },
  {
    id: 'HEALTH_DENTAL',
    description: 'HEALTH / Dental',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: '401K',
    description: '401K',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: 'BASIC_LIFE',
    description: 'Basic Life',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: 'ACCIDENTAL_DEATH',
    description: 'AD&D',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: 'HOLIDAYS',
    description: 'Holidays',
    color: PURPLE,
    ...defaultRate,
  },
  ...COMMON_RATES,
];

export const DEFAULT_DESIGNER_RATE_LIST = [
  {
    id: 'BASE_RATE',
    description: 'BASE RATE',
    color: '#ccfeff',
    ...defaultRate,
  },
  {
    id: 'HEALTH_INSURANCE',
    description: 'HEALTH INSURANCE',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: '401K_MATCH',
    description: '401K MATCH',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: 'ANNUAL_PAID_VACATION',
    description: 'ANNUAL PAID VACATION',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: 'ANNUAL_PAID_HOLIDAY',
    description: 'ANNUAL PAID HOLIDAY',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: 'HAS',
    description: 'HAS',
    color: PURPLE,
    ...defaultRate,
  },
  {
    id: 'AUTO_ALLOWANCE',
    description: 'AUTO ALLOWANCE',
    color: PURPLE,
    ...defaultRate,
  },
  ...COMMON_RATES,
];
